import { Suspense } from 'react'
import { CssBaseline, GlobalStyles } from '@mui/material'
import { Loader, Segment, SnackBar } from 'components'
import { GoogleTagManager } from 'components/Analytics'
import { IframeImpersonationProvider } from 'components/IframeImpersonation'
import { MaestroBar } from 'components/Maestro'
import { UtmParamsProvider } from 'context'
import { Elements } from 'context/StripeElementsContext'
import { Outlet } from 'react-router'
import { globalStyles } from '../theme'

export const App = () => {
  return (
    <UtmParamsProvider>
      <IframeImpersonationProvider>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        <Segment />
        <GoogleTagManager />
        <Elements>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Elements>
        <SnackBar />
        <MaestroBar />
      </IframeImpersonationProvider>
    </UtmParamsProvider>
  )
}
